import * as brandColors from '../../../utils/brandColors';

export default ({
  id: -1,
  name: 'Comment',
  iconColor: brandColors.grey[300],
  icon: 'comment',
  requireComment: false,
});
